import type { FieldErrors, UseFormRegister } from 'react-hook-form'
import clsx from 'clsx'
import { sanitizeFieldName } from '@/utils/sanitizedLabel'

type Props = {
	id: string
	required: boolean
	colSpan?: string
	formStyle: string
	register: UseFormRegister<any>
	errors: FieldErrors
	label: string
	className?: string
}

export default function EmailInput({
	id,
	required,
	colSpan = '1',
	register,
	errors,
	label,
	formStyle,
	className,
}: Props) {
	const fieldName = sanitizeFieldName(label)

	return (
		<div
			className={clsx(
				'form-component',
				{
					'2': 'colSpan2',
				}[colSpan],
				className
			)}
		>
			<div
				className={clsx('form-element-container', formStyle === 'line' && 'line-style')}
				onClick={() => document.getElementById(id)?.focus()}
			>
				<input
					id={id}
					type="email"
					className="input"
					placeholder={''}
					{...register(fieldName, {
						required: {
							value: required,
							message: `${label} is required`,
						},
						pattern: {
							value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
							message: 'Please enter a valid email address',
						},
					})}
				/>
			</div>
			<label htmlFor={id}>{`${label} ${required ? '*' : ''}`}</label>
			{errors && errors[fieldName] && (
				<span className="mt-1 text-red-500">{errors[fieldName]?.message?.toString()}</span>
			)}
		</div>
	)
}
